import { apiClientV2 } from '../../apiClient';
const baseURL = process.env.VUE_APP_REST_API_IDENTITY

export const getCustomDashboard = async () => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/custom-content',
    params: {
      type: 'DASHBOARD'
    },
    headers: {
      namespace: 'identity'
    },
  })

  return response?.data
}